// extracted by mini-css-extract-plugin
export default {"imageWrapper":"lG-z","hovered":"mG-z","hoverImage":"nG-z","mainImage":"oG-z","imageNoBackground":"pG-z","fullSizeImage":"qG-z"};